import { render } from "./NewNoteFab.vue?vue&type=template&id=ab1ae3b0&scoped=true"
import script from "./NewNoteFab.vue?vue&type=script&lang=js"
export * from "./NewNoteFab.vue?vue&type=script&lang=js"

import "./NewNoteFab.vue?vue&type=style&index=0&id=ab1ae3b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1ae3b0"]])

export default __exports__